import { LandingPageViewConfig } from "pages/shared/Dashboard/types";
import { getVINViewLinkParams } from "pages/shared/Dashboard/utils";

import Link from "features/ui/Link";

interface Props {
  config: LandingPageViewConfig;
  vin: string;
}

const VINLink = ({ config, vin }: Props) => (
  <Link to={getVINViewLinkParams(config, vin)}>{vin}</Link>
);

export default VINLink;
